import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common';

export const CloudinarySamplePhotoDetails: React.FC<DynamicComponentProps> = (
  props: DynamicComponentProps
) => {
  return (
    <InspectionChecklist
      {...props}
      defaultHeader="Sample Check"
      completionTranslationKey="sample_check_complete"
    />
  );
};
